<template>
  <v-dialog
    v-if="selected"
    :value="dialog"
    :hide-overlay="!dialog"
    @click:outside.stop="closeDialog(true)"
    @keydown.esc="closeDialog(true)"
    persistent
    max-width="1117px"
    :fullscreen="is_mobile"
    :scrollable="is_mobile"
    overlay-opacity="50"
    overlay-color="#ffffff"
    content-class="default-dialog"
    >
    <v-card class="default-dialog-card">
      <v-card-title class="dialog-title">
        <span class="headline">
          <v-icon class="toolbar-icon">mdi-view-list</v-icon>
          {{ lang.orders.view.order }} #{{ selected.id }}
        </span>
        <v-spacer></v-spacer>
        <v-icon class="dialog-close-btn" @click="closeDialog()">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="pa-0 pr-2">
        <v-container class="px-0">
          <v-row>
            <v-col cols="12" lg="6" md="12" sm="12" xs="12" class="view-info pr-0">
              <v-row>
                <v-col cols="6">
                  <v-subheader>{{ lang.orders.datatable.headers.datetime }}</v-subheader>
                  {{ formatDate(selected.datetime) }}
                </v-col>
                <v-col cols="6">
                  <v-subheader>{{ lang.orders.datatable.headers.status }}</v-subheader>
                  <v-chip
                    :color="getStatus(selected.status).color"
                    class="chip-100p"
                    dark
                  >
                    {{ getStatus(selected.status).title }}
                  </v-chip>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-row>
                    <v-subheader>{{ lang.orders.datatable.headers.customer }}</v-subheader>
                    <CustomerCard v-model="selected.customer" :noneRef="selected.ref" mini />
                  </v-row>
                  <v-row>
                    <v-subheader>{{ lang.orders.datatable.headers.action }}</v-subheader>
                    <Actions
                      v-model="selected"
                      :hideView="true"
                      @edit="$emit('edit', $event)"
                      @repeat="$emit('repeat', $event)"
                    />
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-subheader>{{ lang.orders.datatable.headers.paid }}</v-subheader>
                  <PaymentSummary
                    :order="selected"
                  />
                </v-col>
              </v-row>
              <v-row class="pr-3">
                <v-col cols="12" class="historic">
                  <v-subheader>{{ lang.orders.datatable.headers.history }}</v-subheader>
                  <v-container
                    class="overflow-y-auto"
                    v-bar="{ preventParentScroll: true, scrollThrottle: 30 }"
                  >
                    <v-card
                      v-if="(typeof selected.history !== 'undefined')"
                      class="mx-auto historic-inside"
                      tile
                    >
                      <v-list-item
                        v-for="(history, index) in selected.history.slice().reverse()"
                        :key="`H-${index}`"
                        class="history"
                        two-line
                      >
                        <v-list-item-icon class="history-icon">
                          <v-icon :color="getHistory(history.type).color">
                            {{ getHistory(history.type).icon }}
                          </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="history-content">
                          <v-list-item-title>{{ getHistory(history.type).title }}</v-list-item-title>
                          <v-list-item-subtitle>
                            {{ history.datetime }}
                            <v-tooltip v-if="permissions.orders.historyinfo" top>
                              <template v-slot:activator="{ on }">
                                <v-btn small icon v-on="on">
                                  <v-icon small color="grey lighten-1">mdi-information</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ history.by_name }} ({{ history.by_function }})</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>
                  </v-container>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" lg="6" md="12" sm="12" xs="12" class="px-0 pl-1">
              <OrderList :order="selected.order" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <!-- <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="gray" text @click="closeDialog()">{{ lang.orders.view.close }}</v-btn>
        <v-btn color="red darken-1" text>{{ lang.orders.view.copy }}</v-btn>
        <v-btn color="green darken-1" text>{{ lang.orders.view.print }}</v-btn>
      </v-card-actions> -->
    </v-card>
  </v-dialog>
</template>

<script>
import CustomerCard from '@/components/customers/templates/OrderCard'
import Actions from './templates/Actions'
import OrderList from './templates/OrderList'
import PaymentSummary from './templates/payment/ViewSummary'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import view from '@/mixins/defaults/view'
import orders from './mixins/index'

export default {
  components: { CustomerCard, Actions, OrderList, PaymentSummary },
  mixins: [ appdata, utils, view, orders ],
  watch: {
    dialog (newVal) {
      if (newVal) this.readMark(this.selected)
    }
  },
  methods: {
    sumTotals () {
      var orders = this.selected.order_list
      var subtotal = 0
      orders.forEach(function (item) {
        subtotal = parseFloat(parseFloat(subtotal) + parseFloat(item.price))
      })
      this.selected.subtotal = subtotal
    }
  }
}
</script>

<style src="@/styles/inner/view.scss" lang="scss"></style>
<style scoped src="./styles/index.css"></style>
